import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How do you test the home security systems you review?",
  answer: "Our team conducts hands-on testing in real-world home environments. We evaluate installation ease, app responsiveness, sensor reliability, and professional monitoring speed to ensure every recommendation meets our 'SafeBode Certified' standards."
}, {
  question: "Are the products you recommend compatible with smart home hubs?",
  answer: "Most of our top picks integrate seamlessly with Amazon Alexa, Google Assistant, and Apple HomeKit. We clearly label compatibility in our comparison tables and detailed reviews to help you build a unified smart home."
}, {
  question: "Do I need a professional to install these security cameras?",
  answer: "While we review both DIY and professional systems, many modern smart cameras are designed for simple self-installation. Our buying guides provide step-by-step insights to help you decide which route is best for your technical comfort level."
}, {
  question: "How often are your product ratings and prices updated?",
  answer: "We update our reviews and pricing data monthly. Our automated systems track price changes across major retailers like Amazon and Best Buy, while our experts re-evaluate ratings whenever a significant firmware or hardware update is released."
}];
export default function CommonSafetyQuestions() {
  return <section data-section-id="222322" id="common-safety-questions" className="w-full py-20 md:py-32 bg-background text-foreground">
      <div className="mx-auto px-4 md:px-8 max-w-3xl">
        <div className="text-center mb-16">
          <h2 className="font-default text-3xl md:text-4xl font-bold mb-4 tracking-tight text-primary">
            Common Safety Questions
          </h2>
          <p className="text-muted-foreground text-lg font-default max-w-2xl mx-auto">
            Expert answers to help you make smarter decisions about your home security and family safety.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-none mb-8 last:mb-0 bg-card shadow-sm rounded-2xl overflow-hidden ring-1 ring-border transition-all duration-200 hover:shadow-md">
              <AccordionTrigger className="font-default font-bold text-lg px-6 py-5 hover:no-underline hover:text-secondary transition-colors text-primary data-[state=open]:border-b data-[state=open]:border-border">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="bg-card px-6 pt-5 pb-6 text-base font-default text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}